import { Reducer } from 'react';
import { HttpViewState } from 'store/analytics/ui/analyticsUiTypes';

import {
  SELECT_WEBHOOK_DETAIL_TAB,
  SELECT_WEBHOOK_VIEW_TRIGGER,
  SET_WEBHOOK_SEARCH_KEYWORD,
  SET_WEBHOOK_VIEW_ACTIVE_PAGE,
  SET_WEBHOOK_VIEW_PAGE_SIZE,
  WebhookViewActionTypes,
} from './webhookActionTypes';
import { initialHttpViewState } from '../common/initialValues';

export const webhookViewReducer: Reducer<HttpViewState, WebhookViewActionTypes> = (
  state = { ...initialHttpViewState },
  action,
): HttpViewState => {
  switch (action.type) {
    case SET_WEBHOOK_VIEW_ACTIVE_PAGE:
      return { ...state, activePage: action.payload };
    case SET_WEBHOOK_VIEW_PAGE_SIZE:
      return { ...state, pageSize: action.payload };
    case SELECT_WEBHOOK_VIEW_TRIGGER:
      return { ...state, selectedHttpRequest: action.payload };
    case SELECT_WEBHOOK_DETAIL_TAB:
      return { ...state, selectedViewTab: action.payload };
    case SET_WEBHOOK_SEARCH_KEYWORD:
      return { ...state, searchKeyword: action.payload };
    default:
      return state;
  }
};
